import SvgIcon from "@material-ui/core/SvgIcon";
import * as React from "react";

function DatasetIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 -960 960 960">
      <path
        fill="rgb(0, 0, 0, 0.54)"
        d="M290-290h140v-140H290v140Zm240 0h140v-140H530v140ZM290-530h140v-140H290v140Zm240 0h140v-140H530v140ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
      />
    </SvgIcon>
  );
}

export default DatasetIcon;
